import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const routes: RouteRecordRaw = {
  path: '',
  name: 'FinancialManagement',
  redirect: '/index',
  component: Layout,
  meta: {
    title: '财务协同',
    icon: 'financial-management|svg'
  },
  children: [
    {
      path: 'invoice-management',
      name: 'InvoiceManagement',
      component: () => import('@/views/InvoiceManagement/InvoiceManagement.vue'),
      meta: {
        title: '发票管理',
        module: 'INVOICE_MANAGEMENT',
        hidePageHeader: true
      }
    },
    {
      path: 'invoice-management/upload',
      name: 'InvoiceUpload',
      component: () => import('@/views/InvoiceManagement/invoice-upload/invoice-upload.vue'),
      meta: {
        title: '上传发票',
        parentMenu: '/invoice-management'
      }
    },
    {
      path: 'invoice-management/detail',
      name: 'InvoiceDetail',
      component: () => import('@/views/InvoiceManagement/invoice-detail/invoice-detail.vue'),
      meta: {
        title: '发票详情',
        parentMenu: '/invoice-management'
      }
    },
    {
      path: 'bill-management',
      name: 'BillManagement',
      component: () => import('@/views/BillManagement/bill-management.vue'),
      meta: {
        title: '账单管理',
        module: 'BILL_MANAGEMENT'
      }
    },
    // 账单管理页面跳转发票上传页面，复用发票上传页面
    {
      path: 'bill-management/upload',
      name: 'InvoiceUploadFromBillManagement',
      component: () => import('@/views/InvoiceManagement/invoice-upload/invoice-upload.vue'),
      meta: {
        title: '上传发票',
        parentMenu: '/bill-management'
      }
    },
    {
      path: 'bill-management/detail',
      name: 'BillDetail',
      component: () => import('@/views/BillManagement/bill-detail/index.vue'),
      meta: {
        title: '账单详情',
        parentMenu: '/bill-management'
      }
    },
    {
      path: 'bill-management/list',
      name: 'BillList',
      component: () => import('@/views/BillManagement/bill-list/index.vue'),
      meta: {
        title: '账单明细',
        parentMenu: '/bill-management',
        hidePageHeader: true
      }
    },
    {
      path: 'async-download',
      name: 'AsyncDownload',
      component: () => import('@/views/AsyncDownload/async-download.vue'),
      meta: {
        title: '下载列表',
        module: 'ASYNC_DOWNLOAD'
      }
    }
  ]
}
export default routes
